import { useState, useEffect } from 'react';

export const useOpenCredit = creditCardOfferAccepted => {
    const [isOpenCreditActive, setIsOpenCreditActive] = useState(false);

    useEffect(() => {
        setIsOpenCreditActive(creditCardOfferAccepted);
        // eslint-disable-next-line camelcase
    }, [creditCardOfferAccepted]);

    return { isOpenCreditActive };
};
